import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["practiceAssignment"]

  connect() {
    this.updateDefault()
  }

  updateDefault() {
    const isDefault = this.element.querySelector("input[type='checkbox'][name$='[default]']")?.checked
    const region = this.practiceAssignmentTarget
    region.classList.toggle("opacity-50", isDefault)
    region.classList.toggle("pointer-events-none", isDefault)
    region.querySelectorAll("input, button").forEach(el => { el.disabled = isDefault })
  }
}
